import * as Immutable from "immutable";
import isDeepEqual from "stores/isDeepEqual";
import View from "views/logic/views/View";
import normalizeSearchURLQueryParams from "views/logic/NormalizeSearchURLQueryParams";
const bindSearchParamsFromQuery = async ({ query, view, executionState }) => {
  if (view.type !== View.Type.Search) {
    return [view, executionState];
  }
  const { queryString, timeRange, streamsFilter, streamCategoriesFilter } = normalizeSearchURLQueryParams(query);
  if (!queryString && !timeRange && !streamsFilter && !streamCategoriesFilter) {
    return [view, executionState];
  }
  const { queries } = view.search;
  if (queries.size !== 1) {
    throw new Error("Searches must only have a single query!");
  }
  const firstQuery = queries.first();
  let queryBuilder = firstQuery.toBuilder();
  if (queryString) {
    queryBuilder = queryBuilder.query(queryString);
  }
  if (timeRange) {
    queryBuilder = queryBuilder.timerange(timeRange);
  }
  const combinedFilters = streamsFilter && streamCategoriesFilter ? Immutable.Map({
    type: "or",
    filters: Immutable.List.of(streamsFilter, streamCategoriesFilter)
  }) : streamsFilter || streamCategoriesFilter;
  if (combinedFilters) {
    queryBuilder = queryBuilder.filter(combinedFilters);
  }
  const newQuery = queryBuilder.build();
  if (isDeepEqual(newQuery, firstQuery)) {
    return [view, executionState];
  }
  const newSearch = view.search.toBuilder().queries([newQuery]).build();
  const newView = view.toBuilder().search(newSearch).build();
  return [newView, executionState];
};
export default bindSearchParamsFromQuery;
